import { render, staticRenderFns } from "./TipoUsoLista.vue?vue&type=template&id=d8cc2346&lang=html"
import script from "./TipoUsoLista.vue?vue&type=script&lang=js"
export * from "./TipoUsoLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports